import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../components/Theme/Themecontext";
import { useTranslation } from "react-i18next";
import { useRouteHistory } from "./RoutehistoryContext";

function Footer() {
  const { t, i18n } = useTranslation();

  const { styles } = useTheme();
  const { bluetext } = styles;

  const [activeIndex, setActiveIndex] = useState(0);

  const { setPreviousRoute, setFromQuickAll,setFirstAfterQuickAll,fromQuickAll,firstAfterQuickAll } = useRouteHistory();



  const menuItems = [
    {
      link: "/home",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.02 2.84016L3.63 7.04016C2.73 7.74016 2 9.23016 2 10.3602V17.7702C2 20.0902 3.89 21.9902 6.21 21.9902H17.79C20.11 21.9902 22 20.0902 22 17.7802V10.5002C22 9.29016 21.19 7.74016 20.2 7.05016L14.02 2.72016C12.62 1.74016 10.37 1.79016 9.02 2.84016Z"
            stroke="#FEFEFE"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 17.9902V14.9902"
            stroke="#FEFEFE"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      link: "/home/quickall",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
            stroke="white"
            stroke-miterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 12.8794V11.1194C2 10.0794 2.85 9.21945 3.9 9.21945C5.71 9.21945 6.45 7.93945 5.54 6.36945C5.02 5.46945 5.33 4.29945 6.24 3.77945L7.97 2.78945C8.76 2.31945 9.78 2.59945 10.25 3.38945L10.36 3.57945C11.26 5.14945 12.74 5.14945 13.65 3.57945L13.76 3.38945C14.23 2.59945 15.25 2.31945 16.04 2.78945L17.77 3.77945C18.68 4.29945 18.99 5.46945 18.47 6.36945C17.56 7.93945 18.3 9.21945 20.11 9.21945C21.15 9.21945 22.01 10.0694 22.01 11.1194V12.8794C22.01 13.9194 21.16 14.7794 20.11 14.7794C18.3 14.7794 17.56 16.0594 18.47 17.6294C18.99 18.5394 18.68 19.6994 17.77 20.2194L16.04 21.2094C15.25 21.6794 14.23 21.3994 13.76 20.6094L13.65 20.4194C12.75 18.8494 11.27 18.8494 10.36 20.4194L10.25 20.6094C9.78 21.3994 8.76 21.6794 7.97 21.2094L6.24 20.2194C5.33 19.6994 5.02 18.5294 5.54 17.6294C6.45 16.0594 5.71 14.7794 3.9 14.7794C2.85 14.7794 2 13.9194 2 12.8794Z"
            stroke="white"
            stroke-miterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      link: "/home/Bot",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.2143 16.0709C4.2143 15.2033 4.91816 14.4994 5.78573 14.4994H18.2143C19.0819 14.4994 19.7857 15.2033 19.7857 16.0709V16.7137C19.7857 18.118 19.1176 19.3066 17.815 20.1505C16.5072 20.9989 14.5558 21.4994 12 21.4994C9.44443 21.4994 7.49323 20.999 6.18535 20.1507L4.2143 16.0709ZM4.2143 16.0709V16.7137C4.2143 18.1184 4.88118 19.3071 6.18474 20.1503L4.2143 16.0709ZM11.3572 3.07087L11.8572 2.57087V1.92801C11.8572 1.89013 11.8722 1.85379 11.899 1.827C11.9258 1.80021 11.9621 1.78516 12 1.78516C12.0379 1.78516 12.0742 1.80021 12.101 1.827C12.1278 1.85379 12.1429 1.89012 12.1429 1.92801V2.57087L12.6429 3.07087H16.5C16.9926 3.07087 17.4649 3.26653 17.8132 3.61481C18.1615 3.9631 18.3572 4.43547 18.3572 4.92801V9.6423C18.3572 10.1348 18.1615 10.6072 17.8132 10.9555C17.4649 11.3038 16.9926 11.4994 16.5 11.4994H7.50002C7.25613 11.4994 7.01464 11.4514 6.78932 11.3581C6.564 11.2647 6.35927 11.1279 6.18682 10.9555C5.83854 10.6072 5.64287 10.1348 5.64287 9.6423V4.92801C5.64287 4.43547 5.83854 3.9631 6.18682 3.61482C6.5351 3.26653 7.00747 3.07087 7.50002 3.07087H11.3572ZM7.50002 3.35658C6.63245 3.35658 5.92859 4.06044 5.92859 4.92801V9.6423C5.92859 10.5099 6.63245 11.2137 7.50002 11.2137H16.5C17.3676 11.2137 18.0714 10.5099 18.0714 9.6423V4.92801C18.0714 4.06044 17.3676 3.35658 16.5 3.35658H7.50002ZM4.47253 14.7577C4.82081 14.4094 5.29319 14.2137 5.78573 14.2137H18.2143C18.7068 14.2137 19.1792 14.4094 19.5275 14.7577C19.8758 15.106 20.0714 15.5783 20.0714 16.0709V16.7137C20.0714 18.2225 19.3471 19.4985 17.9705 20.3914C16.5996 21.2787 14.5866 21.7852 12 21.7852C9.41342 21.7852 7.40009 21.2778 6.02899 20.391C4.6529 19.4991 3.92859 18.2233 3.92859 16.7137V16.0709C3.92859 15.5783 4.12425 15.106 4.47253 14.7577ZM10.2143 7.28516C10.2143 7.38834 10.194 7.49051 10.1545 7.58584C10.115 7.68116 10.0571 7.76778 9.98417 7.84074C9.91121 7.9137 9.8246 7.97158 9.72927 8.01106C9.63394 8.05055 9.53177 8.07087 9.42859 8.07087C9.32541 8.07087 9.22324 8.05055 9.12791 8.01106C9.03258 7.97158 8.94596 7.9137 8.873 7.84074C8.80004 7.76778 8.74217 7.68116 8.70268 7.58584C8.6632 7.49051 8.64287 7.38834 8.64287 7.28516C8.64287 7.07677 8.72565 6.87692 8.873 6.72957L8.51945 6.37602L8.873 6.72957C9.02035 6.58222 9.2202 6.49944 9.42859 6.49944C9.63697 6.49944 9.83682 6.58222 9.98417 6.72957C10.1315 6.87692 10.2143 7.07677 10.2143 7.28516ZM15.127 7.84074C14.9797 7.98809 14.7798 8.07087 14.5714 8.07087C14.3631 8.07087 14.1632 7.98809 14.0159 7.84074C13.8685 7.69339 13.7857 7.49354 13.7857 7.28516C13.7857 7.07677 13.8685 6.87692 14.0159 6.72957C14.1632 6.58222 14.3631 6.49944 14.5714 6.49944C14.7798 6.49944 14.9797 6.58222 15.127 6.72957C15.2744 6.87692 15.3572 7.07677 15.3572 7.28516C15.3572 7.49354 15.2744 7.69339 15.127 7.84074Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="bevel"
          />
        </svg>
      ),
    },
    {
      link: "/home/speech",
      icon: (
        <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 19.375C17.7625 19.375 20 17.1375 20 14.375V7.5C20 4.7375 17.7625 2.5 15 2.5C12.2375 2.5 10 4.7375 10 7.5V14.375C10 17.1375 12.2375 19.375 15 19.375Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.4375 12.0625V14.1875C5.4375 19.4625 9.725 23.75 15 23.75C20.275 23.75 24.5625 19.4625 24.5625 14.1875V12.0625" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.2625 8.03789C14.3875 7.62539 15.6125 7.62539 16.7375 8.03789" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 10.6879C14.6625 10.5129 15.35 10.5129 16.0125 10.6879" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 23.75V27.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
      ),
    },
    {
      link: "/home/notification",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.02 2.91016C8.71003 2.91016 6.02003 5.60016 6.02003 8.91016V11.8002C6.02003 12.4102 5.76003 13.3402 5.45003 13.8602L4.30003 15.7702C3.59003 16.9502 4.08003 18.2602 5.38003 18.7002C9.69003 20.1402 14.34 20.1402 18.65 18.7002C19.86 18.3002 20.39 16.8702 19.73 15.7702L18.58 13.8602C18.28 13.3402 18.02 12.4102 18.02 11.8002V8.91016C18.02 5.61016 15.32 2.91016 12.02 2.91016Z"
            stroke="white"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M13.87 3.19945C13.56 3.10945 13.24 3.03945 12.91 2.99945C11.95 2.87945 11.03 2.94945 10.17 3.19945C10.46 2.45945 11.18 1.93945 12.02 1.93945C12.86 1.93945 13.58 2.45945 13.87 3.19945Z"
            stroke="white"
            stroke-miterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.02 19.0605C15.02 20.7105 13.67 22.0605 12.02 22.0605C11.2 22.0605 10.44 21.7205 9.90002 21.1805C9.36002 20.6405 9.02002 19.8805 9.02002 19.0605"
            stroke="white"
            stroke-miterlimit="10"
          />
        </svg>
      ),
    },
  ];

  return (
    <>
      {/* mobile */}
      <footer
        className={`lg:hidden relative flex w-full py-2 h-[60px] bg-[#1552B2] drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none  ${
          i18n.language === "ar" ? "text-right" : "text-left"
        } ${i18n.language === "ar" ? "rtl" : "ltr"}`}
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
      >
        <div className="flex items-center justify-between w-full px-4">
          {menuItems.map((Item, index) => (
            <Link
              to={Item.link}
              onClick={() => {
                setActiveIndex(index);
                if (Item.link === '/home/quickall') {
                  setPreviousRoute('/home/quickall');
                  setFromQuickAll(true);
                  setFirstAfterQuickAll(null); // reset
                } else {
                  if (fromQuickAll && !firstAfterQuickAll) {
                    setFirstAfterQuickAll(Item.link); // track the first route after quickall
                  }
                }
                
                
              }}
            >
              <div>
                <span>{Item.icon}</span>
                <span
                  className={`${
                    activeIndex === index
                      ? "flex items-center justify-center border-b-2 px-[-5px] border-white pb-1 "
                      : ""
                  }`}
                ></span>
              </div>
            </Link>
          ))}
        </div>
      </footer>
    </>
  );
}

export default Footer;
